import { render } from "./PaginationPage.vue?vue&type=template&id=03a05944&ts=true"
import script from "./PaginationPage.vue?vue&type=script&lang=ts"
export * from "./PaginationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__